<template>
  <div>
  
  
  
       

        
        
          <h4  slot="header" class="title">
			Associate
			</h4>
		 <card class="form-horizontal">


		   <div style="padding-bottom:30px;">
		  <br/><strong>Associate's Name:</strong> {{associate.user.user_info.first_name}} {{associate.user.user_info.last_name}}	
		   <br/><strong>Email:</strong> {{associate.user.email}}
		   </div>
   
   
		  </card>
        <!-- end card-->
        
        
        
        
    <div style= "margin-top:50px">     
 		  <h4  slot="header" class="card-title">
      		Add New Commission
    	</h4>
    </div>
  
	 <card class="form-horizontal">
   
		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">Title</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  name="title"
					  v-validate="modelValidations.title"
					  :error="getError('title')"
					  v-model="model.title">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
	     <div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">Amount ($)</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  name="amount"
					  v-validate="modelValidations.amount"
					  :error="getError('amount')"
					  v-model="model.amount">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		
		 <div class="row">
      <label class="col-sm-2 col-form-label">Commission Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                name="date"
              	v-model="model.date" type="date" placeholder="Select A Date"
             	v-validate="modelValidations.date" 
             	 :error="getError('date')"
              	v-bind:class="{ field_error_cs: errors.has('date') }"      
                              >
                              
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('date_incorp')">Sign-up date is required.</span>
      </div>
    </div>
		
		
	</card>    
     <!-- end card-->
    
    
   <card>
		  <div class="text-center" style="">
      		<p-button  type="info" @click.prevent="validate">Add Commission</p-button>
    	</div>
	
	</card>    
        
        
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
	
      	this.initPage();
      	this.model.date = new Date();
    },
    
     
    data () {
      return {
        coy:[],
        associates:[],
        associate:{
        	user:{user_info:[]},
        },
        model:{
        	date:'',
        	title:'',
        	amount:'',
        },
    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          	 required: true,
          },
          amount: {
          	 required: true,
          },
          date: {
            required: true,
          },
        
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	   this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    getError(fieldName) {
        return this.errors.first(fieldName)
      },
      
      manageCommission(row){
      	this.$router.push( '/add-commission/' + row.id);
      },
      
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		  	swal.showLoading();
  		  	this.model.aid = this.associate.user.id;
  		  	
    		let uri = this.$base_url+'/api/v1/entities/post/commission';
      		ApiService.post(uri, this.model).then(response => {
      				const vm = this;
      				if(response.data.message){

							swal({
							  title: 'Done',
							  text: 'Commission has been added successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
							   vm.$router.push( '/view-commission/' + vm.$route.params.aid);
							
							})
					}//end if
         			
     		 })
  		  }
        
         
        })
      },
      
      
      
     
	    initPage(){
	    
	    	let uri = this.$base_url+'/api/v1/entities/get/associate_info/'+ this.$route.params.aid;
			 ApiService.get(uri).then(response => {
				this.associate = response.data.associate;
			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


